import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import CustomCard from '../../../../Components-2025/QuestionBank/CustomCard';
import CustomCardBody from '../../../../Components-2025/QuestionBank/CustomCardBody';
import CustomCardHeader from '../../../../Components-2025/QuestionBank/CustomCardHeader';
import LoaderWrapper from '../../../../Components-2025/QuestionBank/LoaderWrapper';
import QuestionBankFooter from '../../../../Components-2025/QuestionBank/QuestionBankFooter';
import ReportCard from '../../../../Components-2025/QuestionBank/ReportCard';
import Timer from '../../../../Components-2025/QuestionBank/Timer/index';
import ViewQuestion from '../../../../Components-2025/QuestionBank/ViewQuestion';
import questionBankIcon from '../../../../assets/img/question_bank/question_icon_blue.svg';
import ComponentHeader from '../../../../common/ComponentHeader';
import CustomButton from '../../../../common/CustomButton';
import { messages } from '../../../../common/messages';
import { showSuccess } from '../../../../common/toast';
import FlashCard from '../../../../components/FlashCard';
import AppRoutes from '../../../config/AppRoutes';
import { nextAwareRoute } from '../../../../common/cfa1NextRoutes';
import { answerKey, chapterIdKey, correctChoiceKey, questionIdKey, questionKey } from './ApiAttributesKeys';
import apiServiceProvider from './ApiService';
import { isRevisionModeActive, renderHTMLContent } from '../../../../common/function';
import { EXAM_NAMES } from '../../../../common/constant';
import { aiTutorExamYear, aiTutorPageUrl, aiTutorStem, clearAiTutorContext, AI_TRIGGER_BTN_STYLE } from '../../../../common/aiTutorContext';

/* eslint-disable*/

export default class QuestionView extends Component {
  static contextTypes = { router: React.PropTypes.object };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isUserSubscribed: false,
      currentIndex: 0,
      currentQuestion: {},
      showAnswer: false,
      stopTimer: false,
      selectedChoice: '',
      isFlashCardHidden: true,
      questionData: [],
      showReportSection: false
    };
    this.childRef = null;
    this.timerValue = 0;
  }

  setChildRef = (element) => {
    this.childRef = element;
  };

  updateState = (updates) => {
    this.setState(prevState => ({
      ...prevState,
      ...updates
    }));
  };

  async componentDidMount() {
    const { state } = this.props.location;
    if (state && state.questionData && state.questionData.length) {
      const { questionData } = state;
      // fetchQuestions is skipped on this path — take the chapter name from router state
      // (passed by QuestionsList), else the AI Tutor context would have an empty chapter
      this._chapterName = state.chapterName || '';
      this.updateState({ questionData, isLoading: false });
      await this.initializeQuestionState(questionData);
    } else {
      await this.fetchQuestions();
    }
  }

  componentWillUnmount() {
    // leaving the question view → drop stale AI Tutor context
    clearAiTutorContext();
  }

  async componentDidUpdate(prevProps) {
    const { questionId } = this.props.params;
    const prevQuestionId = prevProps.params.questionId;
    
    if (questionId !== prevQuestionId && this.state.questionData.length > 0) {
      await this.initializeQuestionState(this.state.questionData);
    }
  }

  fetchQuestions = async () => {
    const { readingId } = this.props.params;
    try {
      const response = await apiServiceProvider.fetchQuestionsReadingWise({ readingId });
      if (response && response.success) {
        const { questions, selectedExamSubscriptionDetails } = response;
        // chapter name rides along in the all-questions response — kept for AI Tutor grounding
        this._chapterName = (response.chapterName && response.chapterName.chapterName) || '';
        const isSubscribed = selectedExamSubscriptionDetails && selectedExamSubscriptionDetails.level1SubscriptionDetails;
        
        const questionsToShow = isSubscribed 
          ? questions 
          : questions.filter(question => parseInt(question.free, 10) === 1);

        await this.initializeQuestionState(questionsToShow);
        this.updateState({
          questionData: questionsToShow,
          isLoading: false,
          isUserSubscribed: isSubscribed
        });
      }
    } catch (error) {
      this.updateState({ isLoading: false });
    }
  };

  initializeQuestionState = async (questionsData) => {
    this.updateState({ isLoading: true });
    const { questionId } = this.props.params;
    
    const index = questionId
      ? questionsData.findIndex(item => String(item[questionIdKey]) === String(questionId))
      : 0;
    
    const currentQuestion = questionsData[Math.max(0, index)];
    if (!currentQuestion) {
      this.updateState({ isLoading: false });
      return;
    }

    const { selectedChoice, showAnswer, stopTimer, timeDone } = this.getUserAnswerState(currentQuestion);
    this.timerValue = timeDone;

    this.updateState({
      selectedChoice,
      stopTimer,
      showAnswer,
      currentIndex: Math.max(0, index),
      currentQuestion,
      isLoading: false
    });
    // tell the AI Tutor which item the student is viewing (context bar + grounding) —
    // answer state passed explicitly: this.state isn't committed yet in this batch
    this.dispatchAiContext(currentQuestion, { selectedChoice, showAnswer });
  };

  // The full question payload ("explain my answer" grounding). Keys ('choice_b') identify
  // the option; *_text carries what the student actually saw — without it the model is
  // told "your answer: choice_b" and explains blind.
  buildAiItem = (q, selectedChoice) => ({
    questionId: q[questionIdKey],
    stem: q[questionKey],
    chosen: selectedChoice,
    chosen_text: aiTutorStem(q[selectedChoice], 300),
    correct: q[correctChoiceKey],
    correct_text: aiTutorStem(q[q[correctChoiceKey]], 300),
    topic: q.name,
    chapterId: q[chapterIdKey],
  });

  buildAiContext = (q, answer) => {
    // answer state passed explicitly by callers inside setState batches (this.state is
    // stale there); falls back to current state for direct calls
    const a = answer || { selectedChoice: this.state.selectedChoice, showAnswer: this.state.showAnswer };
    const context = {
      exam: 'CFA1',
      exam_year: aiTutorExamYear(), // 2026/2027 from the header's selected exam; null when unknown
      page_url: aiTutorPageUrl(),
      page_type: 'question',
      content_id: q && q[questionIdKey],
      title: q && q.name ? `${q.name} (Q. ${q[questionIdKey]})` : 'CFA Level I',
      // `name` on the question row IS the reading name (e.g. "Natural Resources");
      // chapter name comes from the all-questions response (added server-side for the tutor)
      reading: (q && q.name) || '',
      chapter: this._chapterName || '',
      // the actual question text — the strongest grounding signal for KB retrieval
      // (the title alone, e.g. "Rate and Return", is too generic)
      stem: q && q[questionKey]
        ? String(q[questionKey]).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 400)
        : '',
    };
    // Once ANSWERED, the full item rides inside the context — so a sidebar-opened chat or a
    // typed "explain my answer" knows the question AND the student's choice (not just the
    // on-card ✦ button). Refreshed on every dispatch → always the current question.
    if (q && a.showAnswer && a.selectedChoice) {
      context.item = this.buildAiItem(q, a.selectedChoice);
    }
    return context;
  };

  dispatchAiContext = (q, answer) => {
    if (!q) return;
    const context = this.buildAiContext(q, answer);
    try {
      // global = read by the tutor when opened from the sidebar (timing-proof);
      // event = live-update the context bar while the tutor is already open.
      window.__aiTutorContext = context;
      window.dispatchEvent(new CustomEvent('aitutor:context', { detail: { context } }));
    } catch (e) { /* noop */ }
  };

  explainMyAnswer = () => {
    const { currentQuestion, selectedChoice } = this.state;
    if (!currentQuestion) return;
    try {
      window.dispatchEvent(new CustomEvent('aitutor:explain', { detail: {
        context: this.buildAiContext(currentQuestion),
        item: this.buildAiItem(currentQuestion, selectedChoice),
        message: 'Explain my answer'
      } }));
    } catch (e) { /* noop */ }
  };

  getUserAnswerState = (question) => {
    const selectedChoice = question["question_stats.selected_choice"] || '';
    const rightAnswer = question["question_stats.right_answer"] || '';
    const answerStatus = question["question_stats.answer_status"] || '';
    const timeDone = parseInt(question["question_stats.time_done"] || 0, 10);
    
    let showAnswer = false;
    let selected = '';
    const isRevisionMode = isRevisionModeActive(EXAM_NAMES.CFA_1);

    if (selectedChoice && isRevisionMode) {
      selected = selectedChoice;
      showAnswer = true;
    } else if (answerStatus && isRevisionMode) {
      if (rightAnswer === 1) {
        selected = question[correctChoiceKey];
        showAnswer = true;
      } else if (!rightAnswer) {
        const correct = question[correctChoiceKey];
        const choices = Object.keys(question)
          .filter(key => key.startsWith('choice') && key !== correct);
        selected = choices.length > 0 ? choices[0] : '';
        showAnswer = true;
      }
    }

    return {
      selectedChoice: selected,
      showAnswer,
      stopTimer: !!selected,
      timeDone
    };
  };

  navigateToQuestion = (newIndex) => {
    const { questionData } = this.state;
    const { readingId } = this.props.params;
    const { router } = this.context;

    const questionId = questionData[newIndex] && questionData[newIndex].id;
    if (questionId) {
      router.push({
        pathname: nextAwareRoute(AppRoutes.CFA1_2025_QUESTION_VIEW)
          .replace(':readingId', readingId)
          .replace(':questionId', questionId)
      });
    }
  };

  getPreviousQuestion = async () => {
    const { currentIndex, questionData } = this.state;
    if (currentIndex > 0) {
      await this.initializeQuestionState(questionData);
      this.setState({ showReportSection: false });
      this.navigateToQuestion(currentIndex - 1);
    }
  };

  getNextQuestion = async () => {
    const { currentIndex, questionData } = this.state;
    if (currentIndex < questionData.length - 1) {
      await this.initializeQuestionState(questionData);
      this.setState({ showReportSection: false });
      this.navigateToQuestion(currentIndex + 1);
    }
  };

  validateQuestion = async () => {
    const { selectedChoice, questionData, currentIndex } = this.state;
    if (!selectedChoice) return;

    const currentQuestion = questionData[currentIndex];
    const isCorrect = currentQuestion && currentQuestion[correctChoiceKey] === selectedChoice;
    
    try {
      const data = {
        timeDone: this.timerValue,
        questionId: currentQuestion && currentQuestion[questionIdKey],
        rightAnswer: isCorrect ? 1 : 0,
        selectedChoice
      };
      const result = await apiServiceProvider.saveQuestionAttemptStats(data);

      if (result && result.success) {
        showSuccess(messages.QUESTION_STATS_SAVED);
        const updatedQuestionData = [...questionData];
        updatedQuestionData[currentIndex] = {
          ...currentQuestion,
          [`question_stats.selected_choice`]: selectedChoice,
          [`question_stats.time_done`]: this.timerValue,
          [`question_stats.answer_status`]: result.answer_status || 0,
          [`question_stats.id`]: result.id || currentQuestion["question_stats.id"],
          [`question_stats.right_answer`]: isCorrect ? 1 : 0
        };

        this.updateState({
          stopTimer: true,
          showAnswer: true,
          questionData: updatedQuestionData,
          currentQuestion: updatedQuestionData[currentIndex]
        });
        // the student just answered → republish the AI Tutor context WITH the item, so a
        // sidebar-opened chat / typed "explain my answer" knows the question + their choice
        this.dispatchAiContext(updatedQuestionData[currentIndex], { selectedChoice, showAnswer: true });
      }
    } catch (error) {
      // Handle error silently as per existing behavior
    }
  };

  setAnswer = (answer) => {
    this.updateState({ selectedChoice: answer[0] });
  };

  onSaveItemChange = (status) => {
    this.updateState({ isFlashCardHidden: status });
  };

  toggleReportSection = () => {
    this.setState(prevState => ({ showReportSection: !prevState.showReportSection }));
  };

  getTimerValue = (timerValue) => {
    this.timerValue = timerValue;
  };

  hideReportSection = () => {
    this.updateState({ showReportSection: false });
  };

  render() {
    const {
      isLoading,
      questionData,
      currentIndex,
      currentQuestion,
      showAnswer,
      selectedChoice,
      isFlashCardHidden,
      stopTimer,
      showReportSection
    } = this.state;
    const { readingId } = this.props.params;
    const { router } = this.context;

    const isValidateDisabled = !selectedChoice || !!showAnswer;

    const timeDone = isRevisionModeActive(EXAM_NAMES.CFA_1) && currentQuestion && currentQuestion["question_stats.time_done"] 
      ? parseInt(currentQuestion["question_stats.time_done"], 10) 
      : 0;

    return (
      <div>
        <ComponentHeader title={messages.QUESTION_BANK}>
          <div>
            <CustomButton
              className='mr-1'
              onClick={() => router.push({
                pathname: nextAwareRoute(AppRoutes.CFA1_2025_QUESTIONS_LIST).replace(':readingId', readingId)
              })}
            >
              {messages.CHANGE_QUESTION}
            </CustomButton>
            <CustomButton
              onClick={() => router.push({
                pathname: nextAwareRoute(AppRoutes.CFA1_2025_QUESTION_BANK_READING_LIST).replace(
                  ':chapterId',
                  currentQuestion && currentQuestion[chapterIdKey]
                )
              })}
            >
              {messages.CHANGE_READING}
            </CustomButton>
          </div>
        </ComponentHeader>

        <LoaderWrapper isLoading={isLoading}>
          <CustomCard>
            {currentQuestion && Object.keys(currentQuestion).length > 0 ? (
              <div>
                <CustomCardHeader
                  headingText={`${currentQuestion.name} (Q. ${currentQuestion.id})`}
                  showPreviousButton={true}
                  showNextButton={true}
                  headerImage={questionBankIcon}
                  arrayLength={questionData.length}
                  disabledPreviousButton={currentIndex < 1}
                  disabledNextButton={!(currentIndex < questionData.length - 1)}
                  getPreviousQuestion={this.getPreviousQuestion}
                  getNextQuestion={this.getNextQuestion}
                />
                <CustomCardBody>
                  <Row>
                    <Col sm={9} xs={12}>
                      <ViewQuestion
                        {...currentQuestion}
                        {...this.props}
                        setAnswer={this.setAnswer}
                        showAnswer={showAnswer}
                        correctChoice={currentQuestion && currentQuestion[correctChoiceKey]}
                        selectedChoice={selectedChoice}
                      >
                        <QuestionBankFooter
                          savePayLoad={{
                            question_id: currentQuestion && currentQuestion[questionIdKey]
                          }}
                          validateQuestion={this.validateQuestion}
                          favItemId={currentQuestion && currentQuestion.id}
                          setChildRef={this.setChildRef}
                          apiServiceProvider={apiServiceProvider}
                          onSaveItemChange={this.onSaveItemChange}
                          toggleReportSection={this.toggleReportSection}
                          disabled={isValidateDisabled}
                        />
                      </ViewQuestion>
                    </Col>
                    <Col sm={3} xs={12}>
                      <Timer
                        getTimerValue={this.getTimerValue}
                        stopTimer={stopTimer}
                        shouldFetchFromServer={true}
                        key={currentQuestion && currentQuestion.id}
                        initialTime={timeDone}
                      />
                    </Col>
                  </Row>
                </CustomCardBody>
              </div>
            ) : (
              <h1 className='text-center pt-3 pb-3'>{messages.NO_DATA_FOUND}</h1>
            )}
          </CustomCard>
        </LoaderWrapper>

        {showAnswer && (
          <Row>
            <Col>
              <CustomCard className='font-lusitana font-16px'>
                <CustomCardHeader
                  headingText={selectedChoice === (currentQuestion && currentQuestion[correctChoiceKey]) ? messages.CORRECT : messages.INCORRECT}
                  headerImage=''
                  className={`text-uppercase ${
                    selectedChoice === (currentQuestion && currentQuestion[correctChoiceKey])
                      ? 'text_success'
                      : 'text_failure'
                  }`}
                />
                <CustomCardBody>
                  <div className='mb-2'>
                    <CustomButton onClick={this.explainMyAnswer} btnColor='ai' style={AI_TRIGGER_BTN_STYLE} className='ap-ai-launcher'>✦ Explain my answer</CustomButton>
                  </div>
                  {renderHTMLContent(currentQuestion && currentQuestion[answerKey], "span")}
                </CustomCardBody>
              </CustomCard>
            </Col>
          </Row>
        )}

        <FlashCard
          item={currentQuestion}
          type='question'
          isFlashCardHidden={isFlashCardHidden}
          ref={this.setChildRef}
          exam='cfa1_2024'
        />

        {showReportSection && (
          <ReportCard
            hideReportSection={this.hideReportSection}
            apiServiceProvider={apiServiceProvider}
            itemId={currentQuestion && currentQuestion[questionIdKey]}
            keyId='question_id'
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/QuestionBank/QuestionView/QuestionView.jsx